export const e項目 = {
  予算: "予算",
  前年実績: "前年実績",
  当年実績: "当年実績",
  前年実績比: "前年実績比",
}
